import {EditPermissions} from '../../../../../../../shared/models';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {getEditTypes} from '../../../delegatorUtils';
import {required} from '../../../../../../../shared/utils';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import filter from 'lodash/filter';

export class ChatHubNode {
    action: any = {};

    constructor(nodeType: string) {
        this.action = {
            'actionType': nodeType,
        };
    }

    static toForm(stepData: { [index: string]: any }) {
        return {
            actionParams: this.actionParamsForm(stepData),
            parameters: this.parametersForm(stepData),
            groups: this.groupsForm(stepData)
        };
    }

    static actionParamsForm(stepData: { [index: string]: any }): {} {
        const action = stepData?.action;
        const chatHub = action && action.actionParams && action.actionParams.chathub
            ? action.actionParams.chathub
            : undefined;
        return {
            name: action?.name ? action?.name : '',
            description: action?.description ? action?.description : '',
            imageUrl: chatHub && chatHub.imageUrl ? chatHub.imageUrl : undefined,
            providerId: chatHub && chatHub.providerId ? chatHub.providerId : '',
            instanceId: chatHub && chatHub.instanceId ? chatHub.instanceId : '',
            apiId: chatHub && chatHub.apiId ? chatHub.apiId : '',
            success: action?.result && action?.result.success ? action?.result.success : newStepValue,
            error: action?.result && action?.result.error ? action?.result.error : newStepValue
        };
    }

    static parametersForm(stepData: { [index: string]: any }): {} {
        const action = stepData?.action;
        const paramsList = [];
        const parameters = action && action.actionParams && action.actionParams.chathub && action.actionParams.chathub.parameters
            ? action.actionParams.chathub.parameters
            : undefined;
        if (parameters) {
            for (const key in parameters) {
                paramsList.push({
                    id: key,
                    type: parameters[key].type,
                    value: parameters[key].value,
                });
            }
        }
        return paramsList;
    }

    static groupsForm(stepData: { [index: string]: any }) {
        const action = stepData?.action;
        return action && action.actionParams && action.actionParams.chathub && action.actionParams.chathub.groups
            ? action.actionParams.chathub.groups
            : undefined;
    }

    static getActionTemplate(editPermissions: EditPermissions): FormGroup {

        const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
        return new FormGroup({
            name: new FormControl({value: ''}, [required('Name')]),
            description: new FormControl({value: ''}, [required('Description')]),
            imageUrl: new FormControl(''),
            providerId: new FormControl({value: ''}, [required('Provider ID')]),
            instanceId: new FormControl({value: ''}, [required('Instance')]),
            apiId: new FormControl({value: ''}, [required('API ID')]),
            success: new FormControl(''),
            error: new FormControl('')
        });
    }

    static getParametersTemplate(): FormArray {
        return new FormArray([]);
    }

    static getParameterTemplate(): FormGroup {
        return new FormGroup({
            id: new FormControl(''),
            type: new FormControl(''),
            value: new FormControl(''),
            isArray: new FormControl(false),
            required: new FormControl(false)
        });
    }

    static getParameterTemplateArrayValue() {
        return new FormGroup({
            id: new FormControl(''),
            type: new FormControl(''),
            value: new FormControl([]),
            isArray: new FormControl(false),
            required: new FormControl(false)
        });
    }

    static getGroupsTemplate(): FormArray {
        return new FormArray([]);
    }

    static getGroupTemplate(): FormGroup {
        return new FormGroup({
            id: new FormControl(''),
            name: new FormControl(''),
            items: new FormArray([])
        });
    }

    static getGroupItemsTemplate(): FormArray {
        return new FormArray([]);
    }

    static getGroupItemTemplate(): FormGroup {
        return new FormGroup({
            id: new FormControl(''),
            parameters: new FormArray([])
        });
    }

    get nodeData(): {} {
        return {
            action: this.action,
            'type': 'action',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

    addChatHubParams(providerId: string, actionParams: any, paramsList: any, groupsList: any): void {
        const { imageUrl, instanceId, apiId } = actionParams;
        const parameters = {};
        const groups = {};
        paramsList.map(parameter => {
            const { id, type, value, isArray, required } = parameter;
            parameters[id] = {
                type,
                value,
                isArray,
                required
            };
        });

        groupsList.map(group => {
            const { items } = group;
            const groupParameters = [];
            items.map(item => {
                item.parameters.map((parameter) => {
                    groupParameters.push(parameter);
                });
            });

            const parametersIds = Array.from(groupParameters, ({id}) => id);
            const uniqueParametersIds = [...new Set(parametersIds)];

            uniqueParametersIds.map(id => {
                const filtered = filter(groupParameters, {id});
                groups[id] = {};
                 filtered.map((item, index) => {
                     const { type, value, isArray, required } = item;
                     groups[id][index] = {
                         type,
                         value,
                         isArray,
                         required
                    };
                });
            });
        });

        this.action = {
            ...this.action,
            actionParams: {
                chathub: {
                    imageUrl,
                    providerId,
                    instanceId,
                    apiId,
                    parameters,
                    groups
                }
            }
        };
    }

     addActionParams(name: string, description: string): void {
        this.action = {
            ...this.action,
            name,
            description
        };
    }

    addResult(success: string, error: string): void {
        this.action = {
            ...this.action,
            result: {
                success,
                error
            }
        };
    }
}
